import React from 'react';
import propTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasRole, isLogged } from '../../store/auth/getter';


const PrivateRoute = ({ component: Component, isUserLogged, getHasRole, rolesAccess, ...rest }) => (

  <Route
    {...rest}
    render={(props) => {
      if (!isUserLogged()) {
        return <Redirect to={{ pathname: '/login' }} />;
      }

      // Tester si la route nécessite un role pour s'afficher
      if (!getHasRole(rolesAccess)) {
        // Si la personne n'a pas le role on redirige vers la page d'erreur de droit 401
        return <Redirect to={{ pathname: '/forbidden' }} />;
      }

      //  Si l'utilisateur est connecté et autorisé alors afficher le composant
      return <Component {...props} />;
    }}
  />
);

PrivateRoute.propTypes = {
  component: propTypes.node.isRequired,
  currentUser: propTypes.shape({
    roles: propTypes.arrayOf(
      propTypes.string,
    ),
  }).isRequired,
  getHasRole: propTypes.func.isRequired,
  rolesAccess: propTypes.arrayOf(
    propTypes.string,
  ),
};

PrivateRoute.defaultProps = {
  rolesAccess: [],
};

export default connect(
  state => ({
    currentUser: state.auth,
    getHasRole: rolesAccess => hasRole(state, rolesAccess),
    isUserLogged: () => isLogged(state)

  }),
)(withRouter(PrivateRoute));
